import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title?: string
  description?: string
  canonical?: string
  type?: 'website' | 'article'
  image?: string
}

const defaultMeta = {
  title: 'UC Advisors',
  description:
    'UC Advisors - Your strategic partner for UCaaS, CCaaS, Network, SD-WAN, and Cybersecurity solutions. Serving Credit Unions and Banks with expert technology consulting.',
  image: '/og-image.png',
  siteName: 'UC Advisors',
}

export function SEO({
  title,
  description = defaultMeta.description,
  canonical,
  type = 'website',
  image = defaultMeta.image,
}: SEOProps) {
  const fullTitle = title
    ? `${title} | ${defaultMeta.siteName}`
    : `${defaultMeta.title} | Unified Communications & Contact Center Solutions`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={defaultMeta.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}


